import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/fonts/font.css";
// import axios from "axios";
import Vant from "vant";
import { Toast } from "vant";
import "vant/lib/index.css";
import "./utils/initRem.js";
import MetaInfo from "vue-meta-info";
// 引入 Vconsole
import Vconsole from "vconsole";
import VueClipboard from "vue-clipboard2";
import locale from "element-ui/lib/locale/lang/en";

// 测试环境使用
if (window.location.host !== "www.mastersol.tech") {
  new Vconsole();
}

import {
  setMoment,
  add_comma_toThousands,
  convertDateToTimestamp,
  validateEmail,
  compressAndUpload,
  getBase64Image,
  isMoreThanOneDay,
} from "./utils/funcJS";
import store from "@/store/index.js";

Vue.use(ElementUI, { locale });
Vue.use(MetaInfo);
Vue.use(Vant);
Vue.use(VueClipboard);

Vue.prototype.$setMoment = setMoment;
Vue.prototype.$setNum = add_comma_toThousands;
Vue.prototype.$setTimeStr = convertDateToTimestamp;
Vue.prototype.$validateEmail = validateEmail;
Vue.prototype.$Toast = Toast;
Vue.prototype.$isMoreThanOneDay = isMoreThanOneDay;

// 压缩图片方法
Vue.prototype.$compressImg = compressAndUpload;
// 图片转换64字符串
Vue.prototype.$setBase64Img = getBase64Image;

const whiteList = [
  "home",
  "historyList",
  "placingPage",
  "placingPageJG",
  "homeWeb",
  "historyListWeb",
];

// 注册离线服务
const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register(
        "./service-worker.js"
      );
      if (registration.installing) {
        console.log("正在安装 Service worker");
      } else if (registration.waiting) {
        console.log("已安装 Service worker installed");
      } else if (registration.active) {
        console.log("激活 Service worker");
      }
    } catch (error) {
      console.error(`注册失败：${error}`);
    }
  }
};

// 识别设备端 PC / H5
const distinguishPort = () => {
  let html = document.getElementsByTagName("html")[0];
  var oldWidth = html.clientWidth || document.documentElement.clientWidth;
  let pathNow = router.currentRoute.path;
  if (oldWidth < 800 && pathNow.includes("Web")) {
    router.push(pathNow.slice(0, -3));
  } else if (oldWidth >= 800 && !pathNow.includes("Web")) {
    router.push(pathNow + "Web");
  }
};

window.addEventListener("load", () => {
  registerServiceWorker();
});

window.addEventListener("resize", () => {
  distinguishPort();
});

router.beforeEach(async (to, from, next) => {
  let html = document.getElementsByTagName("html")[0];
  var oldWidth = html.clientWidth || document.documentElement.clientWidth;
  let pathNow = to.path;
  if (oldWidth < 800 && pathNow.includes("Web")) {
    next(pathNow.slice(0, -3));
  } else if (oldWidth >= 800 && !pathNow.includes("Web")) {
    next(pathNow + "Web");
  }
  if (whiteList.indexOf(to.name) > -1) {
    next();
  } else {
    const statusInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (
      statusInfo &&
      (statusInfo.order_status == 0 ||
        statusInfo.order_status == 8 ||
        statusInfo.order_status == 3 ||
        statusInfo.order_status == 10) &&
      localStorage.getItem("token")
    ) {
      next();
    } else if (
      localStorage.getItem("token") &&
      statusInfo.order_status !== 0 &&
      statusInfo.order_status !== 8 &&
      statusInfo.order_status !== 10
    ) {
      let html = document.getElementsByTagName("html")[0];
      var oldWidth = html.clientWidth || document.documentElement.clientWidth;
      if (oldWidth < 800) {
        next("/home");
      } else {
        next("/homeWeb");
      }
    } else if (!localStorage.getItem("token") && to.path !== "/home") {
      let html = document.getElementsByTagName("html")[0];
      var oldWidth = html.clientWidth || document.documentElement.clientWidth;
      if (oldWidth < 800) {
        next("/home");
      } else {
        next("/homeWeb");
      }
    }
  }
});

// axios
//   .get(
//     // "http://114.116.221.105:9090/gateway/ApiService/api/v3/customer/service/info/H5?source=MasterSol"
//     "https://api.mastersol.tech/gateway/ApiService/api/v3/customer/service/info/H5?source=MasterSol"
//   )
//   .then(({ data }) => {
//     localStorage.setItem("customerData", JSON.stringify(data.data));
//   });

Vue.config.productionTip = false;

export default new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
